import { Component, Input, Output, EventEmitter, forwardRef, SimpleChanges, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


/**
   * Logger Factory
   * @namespace items: elements radio to show 
   * @namespace valueSelected: is the value of radio selected to bring to the parent
   * <ute-radio-group [items]="items" (valueSelected)="onChangeValue($event)"></ute-radio-group>
*/

@Component({
  selector: 'ute-radio-group',
  templateUrl: 'ute-radio-group.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=> UteRadioGroupComponent),
    multi: true
  }]
})
export class UteRadioGroupComponent implements OnChanges{
  @Input() items: any[];
  @Input() initialValue: any;
  @Output() valueSelected = new EventEmitter;

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public value: string = '';
  public innerValue: any[];
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() {}
  
  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }
  public writeValue(obj: any) {
    if(obj) {
      this.value = obj;
    } 
  }
  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  onChangeRadio(event){
    this.propagateChange(event);
    this.valueSelected.emit(event);
  }

  ngOnChanges(change: SimpleChanges){
    if(change && change.initialValue){
      this.initialValue = change.initialValue.currentValue;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-radio-group/ute-radio-group.component.ts